<template lang="html">
  <div class="">
    <div class="row mt-3 ml-1">
      <div class="col-2">
        <div class="alert alert-custom font-weight-bold " role="alert">
          PROJECT INSIGHT
        </div>
      </div>
    </div>
    <card class="cardBGCustom mr-3 ml-3">
      <img src='img/ProjectInsightChart.png' alt="..." class="myFrame" /></img>
    </card>

  </div>
</template>

<script>
export default {
  name: "ProjectInsight",
}
</script>

<style lang="css" scoped >
  .alert-custom {
    color: #fff;
    background-color: #00a6aa;
    border-color: #00a6aa;
  }
  .cardBGCustom {
    /* background-color: #5e5e5d !important; */
    background: #a5a5a1ad  !important;
  }
  .myFrame {
    width: 96vw!important;
    height: 71.7vh!important;
  }
</style>
